import api from "lib/axios";
import { ApiEnvelope, unwrapData } from "services/apiTypes";

export type ForceUpdateSettingsPayload = {
  force_update_enabled: boolean;
  soft_update_enabled: boolean;
  ios_min_version: string;
  android_min_version: string;
  ios_latest_version: string;
  android_latest_version: string;
  ios_min_build: number;
  android_min_build: number;
  ios_store_url: string;
  android_store_url: string;
  force_message_ar: string;
  force_message_en: string;
  soft_message_ar: string;
  soft_message_en: string;
};

export const forceUpdateSettingsService = {
  async get(): Promise<ForceUpdateSettingsPayload> {
    const response = await api.get<ApiEnvelope<{ data: ForceUpdateSettingsPayload }>>(
      "/mcp/settings/force-update",
      { meta: { toastSuccess: false } }
    );
    return unwrapData(response.data)!;
  },

  async update(data: Partial<ForceUpdateSettingsPayload>): Promise<ForceUpdateSettingsPayload> {
    const response = await api.put<ApiEnvelope<{ data: ForceUpdateSettingsPayload }>>(
      "/mcp/settings/force-update",
      data
    );
    return unwrapData(response.data)!;
  },
};
